import * as Util from "../common/util";
import * as Data from "../interfaces/data";

export interface ISchedulerSettingsModel {
    Inspectors: IInspector[];
    Views: {};
    MajorTick: number;
    Resources: ISchedulerResourcesViewModel[];
    StartTimeString: string;
    EndTimeString: string;
    IsInspector: boolean;
}

export interface ISchedulerResourcesViewModel {
    text: string;
    value: string;
    color: string;
}

export interface InspectorFilter {
    InspectorID?: string;
}

export interface IScheduleModel {
    TaskID: number;
    InspectorID: string;
    Title: string;
    Description: string;
    StartTimezone: string;
    Start: string;
    End: string;
    EndTimezone: string;
    RecurrenceRule: string;
    RecurrenceID: number;
    RecurrenceException: string;
    IsAllDay: boolean;
    Reschedule: string;
    IsEditable: boolean;
    AppointmentStatus: string;
    AppointmentShortName: string;
    Color: string;
}

export interface IGetAppointmentRequest {
    startDate: string;
    actionView: string;
    calendarInspectors: IInspector[];
}

// interface and class for loading and saving the comment routing info
export interface IInspector {
    ID: string;
    Name: string;
    IsChecked: boolean;
}

export interface IAppointmentSummaryInfo {
    TargetData: Util.IKeyValuePair[];
    AppointmentData: Util.IKeyValuePair[];
}

export function loadAppointments(startDate: string, actionView: string, inspectors: IInspector[]): JQuery.Deferred<Data.IResponse<IScheduleModel[]>> {

    const request: IGetAppointmentRequest = {
        actionView,
        calendarInspectors: inspectors,
        startDate,
    };

    return Util.callWebService(
        "/api/AppointmentCalendar/GetCalendarAppointments",
        "POST",
        request);
}

export function loadSettings(): JQuery.Deferred<Data.IResponse<ISchedulerSettingsModel>> {
    return Util.callWebService(
        "/api/AppointmentCalendar/GetCalendarSetting",
        "POST",
        null,
        false);
}

export function save(action: string, data: IScheduleModel): JQuery.Deferred<Data.IResponse<IScheduleModel[]>> {
    return Util.callWebService(
        "/api/AppointmentCalendar/SaveAppointment",
        "POST",
        data);
}

export function saveInspectors(data: IInspector[]): JQuery.Deferred<Data.IResponse<boolean>> {
    return Util.callWebService(
        "/api/AppointmentCalendar/SaveCalendarInspectors",
        "POST",
        data);
}

export function getAppointmentSummary(id: string): JQuery.Deferred<Data.IResponse<IAppointmentSummaryInfo>> {
    return Util.callWebService(`/api/AppointmentCalendar/GetAppointmentSummary/${id}`, "POST");
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/data/appointmentCalendarData.ts